import Icon, { type IconName } from '@passkeys/ui/icon';
import Text from '@passkeys/ui/text';
import type { ReactNode } from 'react';

import { cn } from '@/ui/utils/classnames.js';

export interface ItemProps {
  children?: ReactNode;
  icon: IconName;
  label: string;
  dataTestId?: string;
  onClick?: () => void;
  description?: string;
}

function Item({
  children,
  description,
  icon,
  label,
  dataTestId,
  onClick,
}: ItemProps) {
  const classes = 'flex w-full flex-col py-4 transition-opacity';

  const content = (
    <>
      <div className="flex w-full items-center justify-between">
        <div className="flex items-center gap-2 text-black theme-dark:text-white">
          <Icon name={icon} />
          <Text size={14}>{label}</Text>
        </div>
        {children}
      </div>
      {description && (
        <Text
          className="ml-8 mt-2 text-gray-500 theme-dark:text-neutral-100"
          size={13}
        >
          {description}
        </Text>
      )}
    </>
  );

  if (!onClick) {
    return <div className={classes}>{content}</div>;
  }

  return (
    <button
      className={cn(classes, 'hover:opacity-70')}
      data-testid={dataTestId}
      onClick={onClick}
      type="button"
    >
      {content}
    </button>
  );
}

export default Item;
